import { propertySourceType } from 'common/constants/property';

export const canDisplayExternalId = (systemSource, feedControlled, externalId) => {
  if (!systemSource || !feedControlled || !externalId) {
    return false;
  }

  const allowedSources = [
    propertySourceType.INTEGRATION,
    propertySourceType.ENTRATA,
    propertySourceType.PUBLIC_GATEWAY,
  ];

  return allowedSources.includes(systemSource);
};
